import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/pages/Home';

import SellingIndex from '@/pages/selling/Index';
import SellingCategory from '@/pages/selling/Category';

import ContentIndex from '@/pages/content/Index';
import ThankYou from '@/pages/content/ThankYou';

import NotFound from '@/pages/notfound/Index';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  hash: false,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/selling',
      name: 'selling',
      component: SellingIndex,
    },
    {
      path: '/selling/:categorySlug',
      name: 'selling-category',
      component: SellingCategory,
    },
    {
      path: '/content/:contentSlug',
      name: 'content',
      component: ContentIndex,
    },
    {
      path: '/thank-you/:communicationType',
      name: 'confirm-submission',
      component: ThankYou,
    },
    // Handle not found
    {
      path: '/notfound',
      name: 'notfound',
      component: NotFound,
    },
    { path: '*', redirect: '/notfound' },
    // Redirects from old site URLs
    {
      path: '/auto.htm',
      name: 'redirect',
      redirect: '/selling/autographs',
    },
    {
      path: '/bbook*.htm',
      name: 'redirect',
      redirect: '/selling/books-and-brochures',
    },
    {
      path: '/btest.htm',
      name: 'redirect',
      redirect: '/selling/benefit-testimonial-brochures',
    },
    {
      path: '/cindex.htm',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/cmain.htm',
      name: 'redirect',
      redirect: '/content/contact-us',
    },
    {
      path: '/contact.htm',
      name: 'redirect',
      redirect: '/content/contact-us',
    },
    {
      path: '/content.htm',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/corner.htm',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/email.htm',
      name: 'redirect',
      redirect: '/content/contact-us',
    },
    {
      path: '/fill.htm',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/index.html',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/index2.htm',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/main.htm',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/mem.htm',
      name: 'redirect',
      redirect: '/selling/memorabilia',
    },
    {
      path: '/nav.htm',
      name: 'redirect',
      redirect: '/',
    },
    {
      path: '/order.htm',
      name: 'redirect',
      redirect: '/content/terms-of-business',
    },
    {
      path: '/sbook.htm',
      name: 'redirect',
      redirect: '/selling/signed-books',
    },
    {
      path: '/sbook2.htm',
      name: 'redirect',
      redirect: '/selling/signed-books',
    },
    {
      path: '/wanted.htm',
      name: 'redirect',
      redirect: '/content/buying',
    },
    {
      path: '/wisden.htm',
      name: 'redirect',
      redirect: '/selling/wisdens',
    },
    {
      path: '/wisden2.htm',
      name: 'redirect',
      redirect: '/selling/wisdens',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js